import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  Injector,
  computed,
  forwardRef,
  inject,
  input,
} from '@angular/core';
import { NgClass } from '@angular/common';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseControlValueAccessor } from '../base-control-value-accessor';

// Not used yet. Delete if nothing ends up needing it.
// Value is stored formatted, "(123) 456-7890", the shape the rating APIs expect.
@Component({
  selector: 'lib-form-phone',
  templateUrl: './form-phone.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatInputModule, MatFormFieldModule, NgxMaskDirective, NgClass],
  providers: [
    provideNgxMask(),
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FormPhoneComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => FormPhoneComponent), multi: true },
  ],
})
export class FormPhoneComponent
  extends BaseControlValueAccessor<string>
  implements AfterContentInit, ControlValueAccessor, Validator
{
  private static nextId = 0;
  private injector = inject(Injector);

  readonly inputId = `form-phone-${FormPhoneComponent.nextId++}`;
  readonly mask = '(999) 999-9999';
  label = input<string>('Phone Number');
  hideRequiredMarker = input<boolean>(false);
  startHint = input<string>();
  endHint = input<string>();
  autocomplete = input<string>('tel');
  pattern = input<string | RegExp>('');
  patternErrorMessage = input<string>();
  readonly = input<boolean>(false);
  alignment = input<'left' | 'center' | 'right'>('left');
  placeholder = input<string>('');
  ariaLabel = input<string>('');

  patternComputed = computed<string | RegExp>(() => this.pattern() || /^\(\d{3}\) \d{3}-\d{4}$/);
  patternErrorMessageComputed = computed<string>(
    () => this.patternErrorMessage() ?? 'Must be a valid phone number like (123) 456-7890',
  );

  ngAfterContentInit(): void {
    const ngControl = this.injector.get(NgControl, null);
    this.control = (ngControl?.control as FormControl) ?? new FormControl();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return control.valid ? null : control.errors;
  }

  onKeyPress(event: KeyboardEvent): void {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  protected override getLabel(): string {
    return this.label() || '';
  }

  override getErrorMessage(errorKey: string): string {
    return errorKey === 'pattern'
      ? this.patternErrorMessageComputed()
      : super.getErrorMessage(errorKey);
  }
}
